import { motion } from "framer-motion";
import styles from "./Portfolio.module.css";
import projects from "../data/projects";

const Portfolio = () => {
  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className={styles.title}>Our Projects</h2>
      <p className={styles.subtitle}>
        A selection of our recent work in full-stack development, custom business tools, and interactive web apps.
      </p>

      <div className={styles.grid}>
        {projects.map((proj, index) => (
          <motion.div
            key={index}
            className={styles.card}
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <h3>{proj.title}</h3>
            <p className={styles.desc}>{proj.description}</p>
            <div className={styles.tech}>
              {proj.tech.map((t, i) => (
                <span key={i}>{t}</span>
              ))}
            </div>
            {proj.link && (
              <a href={proj.link} target="_blank" rel="noreferrer">
                View Project →
              </a>
            )}
          </motion.div>
        ))}
      </div>
    </motion.div>
    
  );
};

export default Portfolio;
